<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="calibre3"><span id="Seite_1" title="[S. 1]"></span></p>
<h2 class="nobreak" id="Der_heilige_Aloysius">Der heilige Aloysius</h2>
</div>
<p class="calibre3"><span>I</span>m Dörfchen Rupertsweiler herrscht reges Leben, seit ein paar Tagen
schon fahren Wagen hochgepackt mit Tannenreisig aus dem nahen Wald und
die würzig duftenden Zweige werden in großen Massen an der Kirche und
den ansehnlichsten Häusern abgeladen. Und abends sitzen die jungen
Mädchen auf den Bänken vor den Häusern und winden unter frommem Gesang
meterlange Gewinde aus Tannenzweigen, während die kleinen Geschwister
rote, weiße oder gelbe Papierblumen hineinbinden.</p>
<p class="calibre3">Fronleichnam steht vor der Tür, und wie jedes Jahr wetteifern alle, wer
den schönsten Schmuck haben würde zur feierlichen Prozession. In den
Häusern ist auch geschäftiges Treiben, die Heiligen werden unter den
schützenden Florhüllen oder Glasstürzen hervorgeholt und wo’s nötig
ist, die Kronen oder Heiligenscheine neu vergoldet, die Sockel mit
Kränzen von leuchtend bunten Papierblumen umwunden. Öllämpchen oder<span id="Seite_2" title="[S. 2]"></span>
gar Leuchter aus Glas oder Silberblech werden geputzt und gefüllt,
um zu Ehren des Allerheiligsten angezündet zu werden, wenn die ganze
Gemeinde, was nur laufen kann, mitzieht durch alle Straßen und bis an
die äußerste Feldgrenze im Triumphzug des Heilands. Die Küfermarie ist
eben fertig geworden mit ihrem letzten Gewinde und reinigt sich jetzt
am Bächlein, das an ihrem Haus vorbeieilt, die harzigen Hände, bindet
eine frische Schürze vor und geht quer über die Straße zum Kirchplatz,
wo das Pfarrhaus steht. Die alte Haushälterin des Pfarrers, Fräulein
Theres, öffnete auf ihr Klopfen und begrüßte die Küfern mit einem
freundlichen: „Ihr wänn wieder der hl. Aloysius hole zum ziere, i han
nen scho runtergeholt us em Gaschtzimmer.“ —</p>
<p class="calibre3">Das war altes Gewohnheitsrecht, daß der Pfarrer seinen Pfarrkindern
von seinem Überfluß an Heiligenbildern und Statuen austeilte, und die
Küfern, die so nah an der Kirche wohnte, hatte immer den Ehrgeiz gehabt
ihre Fenster besonders stattlich auszuputzen, aber eine eigene Statue
sich anzuschaffen, dazu hatte es nie gelangt. Der Mann hätte mit seinem
Küferhandwerk<span id="Seite_3" title="[S. 3]"></span> schon ganz schön verdient in dem weinbautreibenden
Dorfe, wenn er nur den Wein nicht gar so gern selber getrunken hätte.
Jetzt, auf die freundliche Anrede der Pfarrköchin, stand die Frau
verlegen und zupfte am Schürzenzipfel. „Nix für ungut!“ fing sie
schließlich an, „aber wenn’s Euch recht wär, möcht’ i gern än andere
Heilige, nit der hl. Aloysius.“ Die Pfarrköchin zog die Stirn in
Falten: „Jo do komma ner a weng spot, mer hän scho alle hergä — i
ha grad nur der hl. Aloysius für Euch ufg’hobe. — Ihr hänn en doch
alli Jahr ghät.“ — „Scho, scho, freili,“ meinte zögernd die Küfern,
„gar nix hän er meh? Nei, der hl. Aloysius nem i et, lieber stell i
gar nix na.“ Trotzig klingt’s, und die Pfarrköchin, die eigentlich
ungeduldig war, zu ihren Kränzen zurückzugehen, horchte neugierig
auf: „Jo ä Kruzifix hätte mer scho no.“ „Dös han i selber,“ meinte
brummig die Küferfrau, „dös hängt mer doch nit gern zum ziere naus am
Fronleichnigstag, — a Tafla werdener doch no ha?“ fragt sie drängend,
und da sie merkt, wie die Haushälterin eilig ist, setzt sie hinzu:
„Wenn Ihr Müh dervo hänt, i ka warte, i bin fertig mit de Kränz, wenn
Ihr wänn, kann i helfe kränzle,<span id="Seite_4" title="[S. 4]"></span> und derweil überlegt Ihr’s, ob Ihr nix
andersch meh hän.“</p>
<p class="calibre3">Die Pfarrköchin, die alle Hände voll zu tun hatte, war froh um die
angebotene Hilfe, und die beiden sitzen sich bald im Hof gegenüber
unter einem Berg von Tannenzweigen, die noch kunstvoll auf Bretter
genagelt werden mußten. Auf dem dunklen Tannengrün werden weiße
Papierrosen befestigt, die die Namenszüge <span class="antiqua">J. H. S.</span> und auf zwei
andern <span class="antiqua">M(aria)</span> und <span class="antiqua">J(oseph)</span> bilden sollen. Das Ganze
wurde dann genau in die drei Frontfenster eingepaßt. Das hatte die
Pfarrköchin in der Stadt gesehen und war sehr stolz auf diesen neuen
Schmuck, und die Küferfrau war zuerst ganz stumm vor Bewunderung und
Neid. „Nei, wo hän Ihr au nur immer die neue Ifäll här,“ sprudelte
sie dann los, „do kann usereins sich heimgige lo, immer s’glich, amol
rote un amol gäle Rose, aber susch“ — „Do derdrum wän Ihr der hl.
Aloysius nimme?“ fragte die Pfarrköchin nun direkt. „Jo, do drum au,“
meint zögernd die Küfern, „aber nei, warum soll i denn lüage, i ha
gar nit dra denkt, andersch z’ziere wie suscht — aber wissener — i
ha ne Hühnle z’rupfe mit em hl. Aloysius, un<span id="Seite_5" title="[S. 5]"></span> do drum will i en nit
ha zum ziere dös Jahr, nei wissener, der verdient’s bei Göscht nit,“
setzte sie in ausbrechendem Ärger hinzu. Die Pfarrköchin bekreuzt
sich erschrocken, und die Küfermarie schlägt sich auf den Mund: „Gott
verzeih mer d’Sünd — i schwätz halt alls, wie mer der Schnabel gwachse
isch — jo, aber wenn i verzähl, wie’s mer gange isch — no werdet’s
Ihr selber isehe — daß i Recht han. Ihr kenne jo der Karli — mei Ma
— er wär ganz ordentli — i kann grad suscht nit kloge — bis ufs
suffe — wen er Eine hät, no isch nimme mit em uszkomme. Im Frühjahr,
wie n’i uf der Lindeberg gwallfahrtet ha, hän i halt au wieder do dra
denkt, un ’s Weine isch mir ko, wenn i dra denkt ha, was i scho bett
und bett ha bei nere jede Wallfahrt, un nie nit hät die lieb Mutter
Gottes gholfe. Nei wissener, i hann mer jo gsait, daß dös a bsunderi
Gnad wär, un daß i deß nit so verlange ka, i bin a arme sündige Mensch,
aber i ha grad gmeint, unser lieber Herrgott könnt mer amol a anderi
Buß uflege, ’s tragt si lichter, wenn mer amol wechsle ka — un wie n’i
so gweint ha — hät mi a Nachbari, i ha se witers nit kennt, se war von
der andere Site<span id="Seite_6" title="[S. 6]"></span> vom Berg z’Hus, die hät mi agschtoße und hät gmeint:
‚Ha jetzt, was weinener au so? Wenn’s Euch so ’s Herz abdruckt — i
ha’s au amol so ghätt — i han dem hl. Aloysius a Noväne globet un a
Kerze, un er hät mer gli gholfe. Hän Ihr dös scho amol tua?‘“ — „I hän
mir gli denkt, dös isch a Wink vo der Mutter Gottes, si ka do au nit
alles selber mache, mer tät jo ganz die andere liebe Heilige hinte dra
setze, wenn sie alles mache wot, han i nit recht?“ Und die Pfarrköchin
mit ihrer besseren Bildung bestätigte das, indem sie sagte: „Uf dere
Welt isch’s ja au eso, der König und die Königin machet au nit alles
selber, und jedes hät si Posta, mit sine bsundere Pflichte.“</p>
<p class="calibre3">„Freili jo,“ nickt die Küfern, die’s jetzt eilig hatte, ihr Herz gar
vollends auszuschütten, „un wo’n i do scho sit Jahre der hl. Aloysius
zum Ziere gno hä, ’s war jo zu dütli ä Wink. No natürli han i au uf
der Schtell a Noväne globet un a Kerz, un weil i gar ä so sicher war,
daß dös a Wink von der liebe Mutter Gottes war, hän i a silbernes Herz
globet — i han’s erscht versproche, wenn mei Ma ganz ’s Sufe si glasse
hät, sell isch wahr. — Jetzt höret no<span id="Seite_7" title="[S. 7]"></span> — i komm vo der Wallfahrt nach
Hus, ame Suntig Obig isch ’s gsi — un wian’i daher komm, hockt der
Karli bei Göscht uf em Bänkli vor der Tür. Wo ner doch soscht erscht am
Montig in der Fruah usem Wirtshus komme isch.</p>
<p class="calibre3">‚Karli, fehlt der was?‘ hän i’n gfragt. ‚Nit, daß i wüßt,‘ sait er, ‚i
ha nur kei Lust ghet i’s Wirtshus z’go,‘ sait er, ‚’s isch so friedli
do z’hocke am Suntig Obig.‘ ‚O du gütiger, du süßer hl. Aloysius,‘
han i denkt, ‚dös isch dei mächtige Fürsprach, un glei morn fang i
d’Andacht a.‘ Un so han i’s ghalte, un d’Kerz han i an sei Altar
gschtiftet, er hät lang kei so große meh ghätt.</p>
<p class="calibre3">Un daß i’s kurz mach, a ganze Monet lang isch der Karli i kei Wirtshus
meh ganga, un gschafft hät er im Hof mit de Fässer, daß es a wahri
Freud war, un gsunge dabi luschtige Schelmeliedle, un i han nit gwußt,
was i dem hl. Aloysius antua soll vor Freuda — jo un dann hätt der
Karli au agfange lieb z’tua un mir z’schmeichle, wia i de erschte
Woche, wie mer ghirot kha hän, un i ha mi grad gschämt, un Geld hät er
mer gä — — do bin i in<span id="Seite_8" title="[S. 8]"></span> d’Stadt glaufe i meinere Freud un han dem hl.
Aloysius a schön’s silberig’s Herz kauft, des gschenkt Geld vom Karli
un mei ganz Gschparts han i hergä derfür — ’s wär nit nötig gsi — i
ha’s erscht globet kha, wenn der Karli ganz gbessert gwese gsi wär, un
i hätt guat no a Monet oder zwo zuwarte könne — aber i han mi halt so
gfreut über die wirksam Fürsprach, jo und wian’i z’Hus komma bin, i bin
schneller gsi als suscht, weil i au gar so a lichts Herz kha ha — do
han i d’Bscherig gsehe.</p>
<p class="calibre3">Jetzt han i gwüßt, warum der Karli so gern ‚friedli‘ vor dere Hustür
ghockt hät un nimmi ins Wirtshus hät wölle. Über der Zaun über hät er
mit der nia Magd von’s Vogte scharmuziert, un i han wohl gsähe, daß dös
nit zum erschtemal gsi isch, un von wege seim schlechte Gwisse isch
er a so duckmäuserig gsi un hät mer flattieret, daß i nix merke soll.
Z’erscht isch mir d’Wut über den Duckmäuser ko, ’vor er nur gwußt hät,
daß i nen gsehne ha, han i em eis übergwischt, wo’n er dra denke wird,
un d’Meinig han i em au gsagt, ihm un dem schlechte Mensch — die were
nimmi viel Freud mitenander ha. Der Karli isch in seim Zorn natürli<span id="Seite_9" title="[S. 9]"></span>
glei ins Wirtshus gloffe, un so bsoffe wia in dera Nacht isch er scho
lang nimme gsi, un so goht’s jetzt widersch, ’s isch schier nimma mit
em us’ko. — Jo seh’n er, sither han i grad a Zorn, wenn i a der hl.
Aloysius denk — Gott verzeih mer d’Sünd, si nitägig Andacht un die
großmächtig Kerz hät er gha, un’s silberig Herz han i em kauft, Gottlob
han i’s no nit an der Altar ghängt — un ä so bhütet er mer mei Mann.
So hän mer nit gwettet — zrucknehme kann i em d’Kerz un d’Andacht
nimmi — aber in mei Hus kommt er mer nimme — sell weiß i.“ Zornig
schlug sie den letzten Zweig auf das Brett fest und wischte sich dann
energisch die Hände an der guten Schürze ab — die Pfarrers-Theres
hatte sich auch erhoben und meinte bedächtig: „Hütet Euch der Sünd,
Küfern, i mein alls, so derfet Er do nit spreche, — aber i ha mer’s
durch de Kopf go lasse, i han no a Tafla vo der hl. Elisabeth, die hät
au a Huskrüz ghätt mit ihrem zornmütige Ma, wänn Er die ha? Und wenn
Er die vielleicht aruft — vielleicht hilft die ehnder no, die kennt
si eher us mit so na Sache.“ Die Küfern zog erfreut mit ihrer Tafel
ab, und als am andern Morgen die<span id="Seite_10" title="[S. 10]"></span> Prozession an ihrem Haus vorüberzog,
nickte sie der hl. Elisabeth verständnisvoll zu: „Gelt, du hütsch mer
mei Hus besser, ’s isch gfehlt, wenn mer sich uf d’Mannsbilder verlaßt,
die halte alli zsamme, wenn’s gege us Wiber goht.“</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?e84242d4